import Vue from 'vue'
import axios from 'axios'
import { Dialog } from 'vant';
import store from '@/store'
import { VueAxios } from './axios'
import { Tip } from '@/utils';
import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'
import { login } from "@/utils/login";
Vue.use(Dialog)
let apiBaseUrl = process.env.VUE_APP_API_BASE_URL
let apiBaseUrl2 = process.env.VUE_APP_API_BASE_URL2



let apiBaseUrlUpload = apiBaseUrl2 + '/sys/common/upload2'
let apiBaseUrlDownload = apiBaseUrl2 + '/'
let apiContactAvatar = apiBaseUrl2 + '/jksaas-mgt/mgt/sys/common/static2/'
//console.log("apiBaseUrl= ",apiBaseUrl)
// 创建 axios 实例
const service = axios.create({
  //baseURL: '/jeecg-boot',
  baseURL: apiBaseUrl, // api base_url
  timeout: 9000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    let data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    console.log('------异常响应------', token)
    console.log('------异常响应------', error.response)
    if (error.response.status == 200) {
      console.log('code为 200 ')
    } else {
      if (error.response.data.message.includes('Token失效')) {
        login()
          .then(res => {
            window.location.reload()
          })
          .catch((e) => {
            if (e && e.rejectType == 'browser') {
              store.dispatch('Logout').then(() => {
                Vue.ls.remove(ACCESS_TOKEN)
                window.location.reload()
              })
            }
          })
      } else {
        Tip.error(response.data.message)
      }
    }
    return
    switch (error.response.status) {
      case 403:
        Tip.error('拒绝访问')
        break
      case 500:
        console.log('------error.response------', error.response)
        // update-begin- --- author:liusq ------ date:20200910 ---- for:处理Blob情况----
        let type = error.response.request.responseType
        if (type === 'blob') {
          blobToJson(data)
          break
        }
        // update-end- --- author:liusq ------ date:20200910 ---- for:处理Blob情况----
        //Tip.error({ message: '系统提示', description:'Token失效，请重新登录!',duration: 4})
        // if (token && data.message.includes('Token失效')) {
        //   Dialog.confirm({
        //     title: '登录已过期',
        //     message: '很抱歉，登录已过期，请重新登录',
        //     confirmButtonText: '重新登录'
        //   })
        //     .then(res => {
        //       store.dispatch('Logout').then(() => {
        //         Vue.ls.remove(ACCESS_TOKEN)
        //         try {
        //           let path = window.document.location.pathname
        //           console.log('location pathname -> ' + path)
        //           if (path != '/' && path.indexOf('/user/login') == -1) {
        //             window.location.reload()
        //           }
        //         } catch (e) {
        //           window.location.reload()
        //         }
        //       })
        //     })
        // }
        break
      case 404:
        Tip.error('很抱歉，资源未找到!')
        break
      case 504:
        Tip.error('网络超时')
        break
      case 401:
        Tip.error('未授权，请重新登录')
        if (token) {
          store.dispatch('Logout').then(() => {
            setTimeout(() => {
              window.location.reload()
            }, 1500)
          })
        }
        break
      default:
        Tip.error(data.message)
        break
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  let prefix = store.state.user.currentPrefix || '/jksaas-mgt/mgt'

  if (config.url.includes("/jksaas-produce/produce")) {
    prefix = ""
  }

  let slash = config.url.charAt(0) == '/'
  config.url = apiBaseUrl + prefix + `${slash ? config.url : '/'+config.url}`;
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['X-Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  //update-begin-author:taoyan date:2020707 for:多租户
  let tenantid = Vue.ls.get(TENANT_ID)
  if (!tenantid) {
    tenantid = 0
  }
  config.headers['tenant_id'] = tenantid
  //update-end-author:taoyan date:2020707 for:多租户
  if (config.method == 'get') {
    if (config.url.indexOf('sys/dict/getDictItems') < 0) {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      }
    }
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
  return response.data
}, err)

const installer = {
  vm: {},
  install(Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

/**
 * Blob解析
 * @param data
 */
function blobToJson(data) {
  let fileReader = new FileReader()
  let token = Vue.ls.get(ACCESS_TOKEN)
  fileReader.onload = function () {
    try {
      let jsonData = JSON.parse(this.result)  // 说明是普通对象数据，后台转换失败
      console.log('jsonData', jsonData)
      if (jsonData.status === 500) {
        console.log('token----------》', token)
        if (token && jsonData.message.includes('Token失效')) {
          store.dispatch('Logout').then(() => {
            Vue.ls.remove(ACCESS_TOKEN)
            window.location.reload()
          })
        }
      }
    } catch (err) {
      // 解析成对象失败，说明是正常的文件流
      console.log('blob解析fileReader返回err', err)
    }
  }
  fileReader.readAsText(data)
}

export {
  installer as VueAxios,
  service as axios,
  apiBaseUrl,
  apiBaseUrl2,
  apiBaseUrlUpload,
  apiBaseUrlDownload,
  apiContactAvatar
}
